module.exports = __webpack_public_path__ + "img/title-dver-1-m@3x.1a81767e.png";